import React from 'react'
import { Col, FormGroup, Input, Button } from 'reactstrap'
import arrayify from '../../../helpers/arrayify'

export default function ParentChildAdder (props) {
  const nullOption = <option key={props.parentOrChild + 'null'} value=''></option>
  let options = <option key={props.parentOrChild + 'null'} value=''></option>
  if (props.nodesAvail) {
    const nodesAvailArray = arrayify(props.nodesAvail)
    options = nodesAvailArray.map( (node) => {
      return <option key={props.parentOrChild + 'adder' + node.id} value={node.id}>{node.name}</option>
    })
    options.splice(0, 0, nullOption)
  }

  return (
    <div>
      <FormGroup>
        <Input 
          type='select' 
          name={`add${props.parentOrChild}Val`} 
          value={props.selectedNodeId}
          onChange={props.handleChange}
        >
          {options}
        </Input>
        <Button
          onClick={() => props.saveParentChild(props.parentOrChild) }
          disabled={props.selectedNodeId === ''}
        >
          Add {props.parentOrChild} and Save
        </Button>
      </FormGroup>
    </div>
  )
}

// nodesAvail (array), parentOrChild (string) 


// WEBPACK FOOTER //
// ./src/components/Content/KnowledgeMap/ParentChildAdder.js